<template>
  <v-card :width="$vuetify.breakpoint.mdAndUp ? '50%' : '100%'">
    <v-card-title class="align-start pb-0">
      <v-icon class="mr-5">
        {{ icons.mdiCartPlus }}
      </v-icon>
      Add-Ons
      <v-spacer></v-spacer>
      {{ booking.addOns | currency }}
    </v-card-title>
    <v-card-text class="mt-2">
      <v-data-table
        :headers="tableColumnHeaders"
        :items="list"
        item-key="addOnId"
        hide-default-footer
      >
        <!-- date -->
        <template #[`item.createdOn`]="{item}">
          <div class="d-flex align-center">
            <div class="d-flex flex-column ms-3">
              <span class="d-block text--primary  font-weight-semibold text-truncate">{{ item.createdOn | date(false) }}</span>
              <span class="text-xs">{{ item.user }}</span>
              <span class="text-xs">{{ item.note }}</span>
            </div>
          </div>
        </template>

        <template #[`item.active`]="{item}">
          {{ item.amount | currency }}
        </template>
        <template #[`item.amount`]="{item}">
          {{ item.amount * item.quantity| currency }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mdiCartPlus } from '@mdi/js'
import getAddOnsList from '@/components/lists/addOns'

export default {
  components: {
  },
  props:
      {
        booking: {
          type: Object,
          required: true,
        },

      },
  setup(props) {
    const list = ref([])
    const tableColumnHeaders = [
      {
        text: '#ID',
        align: 'start',
        value: 'addOnId',
      },
      { text: 'Fecha/Autor', value: 'createdOn' },
      { text: 'Nombre', value: 'name' },
      { text: 'Cant.', value: 'quantity' },
      { text: 'P.U.', value: 'active' },
      { text: '$', value: 'amount' },
    ]

    const refresh = () => {
      getAddOnsList(props.booking.bookingKey)
        .then(data => {
          list.value = data
        })
    }

    onMounted(refresh)

    return {
      refresh,
      list,
      tableColumnHeaders,
      icons: { mdiCartPlus },
    }
  },
}
</script>
